




<template>
<div>
<v-card>
  <v-toolbar dark  color="#4A76A8" flat  height="42">
  <v-icon large>mdi-account-multiple</v-icon>   <v-toolbar-title  >     {{tasks.task.info.name}}   </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-icon @click="tasks.modals.accounts = false">mdi-close</v-icon>
  </v-toolbar>

<v-card-text fluid style="height:60vh; overflow-x:hidden">


  <div v-for=" item  in this.tasks.task.accounts" >



    <v-checkbox
     color="#4A76A8"
     v-model="tasks.task.accountsSelected"
     v-bind ='[{label:item.title},{value:item.id}]'

     >
     <v-avatar slot="prepend" size="25">
       <img :src="item.photo_50">
     </v-avatar>
    </v-checkbox>





  </div>

</v-card-text>

<v-card-actions>
<v-spacer></v-spacer>
<v-btn color="#4A76A8" flat small @click.native="tasks.modals.accounts=false">Закрыть</v-btn>
<v-btn color="#4A76A8" small class="white--text" @click="changeAccounts()" >Сохранить </v-btn>
</v-card-actions>


</v-card>
</div>
</template>

<script>

import axios from 'axios'
export default {
props:['tasks' ],
  data () {
    return {


    }
  },
methods:{
  changeAccounts(){


    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/change_accounts.php', {
         method: 'POST',
         data: {
           accounts: this.tasks.task.accountsSelected,
           taskId: this.tasks.task.info.task_id
         }
       })
       .then( response => {
      this.tasksData()
       })


  },

  tasksData: function(){

    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
         method: 'POST',
         data: {
           contentType: 'content'
         }
       })
       .then( response => {
         response.data.forEach(
        (item,i,arr)=>{
          item.status = JSON.parse(item.status)
        }
      )
         this.tasks.tasksList = response.data
         this.tasks.modals.accounts = false

       })

  },

},
beforeDestroy() {

}

}
</script>

<style   >

</style>
